import React from "react";
import styles from "./index.module.scss";

const LeapPersonalization = ({ leapPersonalizationData }) => {
  if (!leapPersonalizationData) return null;

  const { description = "", images = [] } = leapPersonalizationData;

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.imageWrapper}>
          {images.map(img => {
            const { imageUrl, alt } = img.fields || {};
            if (!imageUrl) return null;

            return (
              <img
                key={img.sys.id}
                src={imageUrl}
                alt={alt || ""}
                className={styles.image}
              />
            );
          })}
        </div>

        {description && (
          <div className={styles.textWrapper}>
            <h2 className={styles.description}>{description}</h2>
          </div>
        )}
      </div>

      <hr className={styles.divider} />
    </section>
  );
};

export default LeapPersonalization;
